import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';

const BASE_URL = NAMESPACES.management_api.third_party_providers_config;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Initialize TPP Configuration
export const initializeTPPConfig = async (configData: {
  local_id: number;
  third_party_provider_id: number;
  external_local_id: string;
  config: any;
}) => {
  return await retryWithBackoff(() => api.post('/InitializeTPPConfig', configData));
};

// Get TPP Configuration
export const getTPPConfig = async (data: {
  local_id: number;
  third_party_provider_id: number;
}) => {
  return await retryWithBackoff(() => api.post('/GetTPPConfig', data));
};

// Delete TPP Configuration
export const deleteTPPConfig = async (data: {
  local_id: number;
  third_party_provider_id: number;
}) => {
  return await retryWithBackoff(() => api.delete('/DeleteTPPConfig', { data }));
};
